import React from 'react';

const ProductOverview = () => {
    return (
        <section className="w-full py-16 lg:py-24 flex items-center justify-center select-none">
            <div style={{ background: "linear-gradient(180deg, #F3F5FF 0%, #E5ECFF 100%)" }} className="max-w-[1280px] w-full flex flex-col md:flex-row overflow-hidden p-6 sm:p-8 lg:p-[77px] items-stretch gap-6 lg:gap-12">

                <div className="w-full md:w-full max-w-[404px] min-h-[250px] md:min-h-[317px] relative bg-[#031525] flex-shrink-0">
                    <img
                        src="/assets/hrms/img1.png"
                        alt="Product Overview Spheres"
                        className="w-full h-full object-cover"
                    />
                </div>

                <div className="w-full md:w-full max-w-[664px] flex flex-col justify-center text-left py-4">
                    <h2 className="text-[20px] sm:text-[30px] font-[600] font-sora text-[#01386A] tracking-tight mb-6">
                        Product Overview
                    </h2>

                    <p className="text-[14px] sm:text-[16px] font-graphik text-[#49577A] font-[500] leading-relaxed mb-5">
                        Managing a hospital means coordinating patients, doctors, appointments, billing, pharmacy, and administration. Handling this across disconnected systems creates inefficiencies, delays, and inconsistent data.
                    </p>

                    <p className="text-[14px] sm:text-[16px] font-graphik text-[#49577A] font-[500] leading-relaxed">
                        Our Hospital Management System centralizes every operation into a single platform — helping healthcare providers streamline workflows, improve efficiency, and deliver a better patient experience.
                    </p>
                </div>

            </div>
        </section>
    );
};

export default ProductOverview;